import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import { ArrowLeft, Download, Filter } from "lucide-react";

const ProjectStatistics: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    window.history.back();
  };

  const [selectedFilter, setSelectedFilter] = useState("status");

  // Mock data for statistics tables
  const statusStatistics = [
    {
      id: 1,
      category: "GIAI ĐOẠN XÉT DUYỆT THUYẾT MINH",
      count: 5,
      isMain: true,
    },
    {
      id: 2,
      category: "Phê duyệt danh mục thực hiện",
      count: 2,
      isMain: false,
    },
    { id: 3, category: "Nhận hồ sơ thuyết minh", count: 3, isMain: false },
    { id: 4, category: "Thông qua thuyết minh", count: 0, isMain: false },
    { id: 5, category: "Thẩm định kinh phí", count: 0, isMain: false },
    { id: 6, category: "Phê duyệt thực hiện", count: 0, isMain: false },
    { id: 7, category: "ĐỀ TÀI ĐANG THỰC HIỆN", count: 1, isMain: true },
    { id: 8, category: "Đúng tiến độ", count: 1, isMain: false },
    { id: 9, category: "Đã gia hạn", count: 0, isMain: false },
    { id: 10, category: "Quá hạn", count: 0, isMain: false },
    { id: 11, category: "Nghiệm thu sản phẩm", count: 0, isMain: false },
    { id: 12, category: "Họp tổ chuyên gia", count: 0, isMain: false },
    { id: 13, category: "Nghiệm thu cấp cơ sở", count: 0, isMain: false },
    {
      id: 14,
      category: "Nghiệm thu – Nhiệm vụ hoàn thành",
      count: 0,
      isMain: false,
    },
    {
      id: 15,
      category: "NHIỆM VỤ ĐÃ HOÀN THÀNH (2025)",
      count: 0,
      isMain: true,
    },
  ];

  const managementLevelStatistics = [
    {
      level: "Cấp Quốc gia",
      proposing: 1,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      level: "Cấp Bộ",
      proposing: 1,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      level: "Cấp Tỉnh/Thành phố",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      level: "Cấp Viện/ Chi nhánh",
      proposing: 3,
      ongoing: 1,
      behind: 0,
      completed: 0,
      total: 4,
    },
    {
      level: "Cấp khác",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
  ];

  const unitStatistics = [
    {
      unit: "Viện Khoa học Thủy lợi Miền Nam",
      proposing: 1,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      unit: "Viện Khoa học Thủy lợi Miền Trung và Tây Nguyên",
      proposing: 1,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      unit: "Viện Nước, Tưới Tiêu và Môi trường",
      proposing: 0,
      ongoing: 1,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      unit: "Viện Thủy công",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Viện Bơm và Thiết bị thủy lợi",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Viện Thủy điện và năng lượng tái tạo",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Viện Kinh tế và Quản lý thủy lợi",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Viện Kỹ thuật Biển",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Phòng Thí nghiệm trọng điểm Quốc gia về động lực học sông biển",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Trung tâm Đào tạo và Hợp tác Quốc tế",
      proposing: 3,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 3,
    },
    {
      unit: "Trung tâm phòng trừ Mối và sinh vật có hại",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Trung tâm công nghệ phần mềm thủy lợi",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      unit: "Trung tâm Tư vấn quản lý thủy nông có sự tham gia của người dân",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
  ];

  const researchFieldStatistics = [
    {
      field: "Chiến lược thủy lợi của các vùng, miền và quốc gia",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field:
        "Quy hoạch phát triển và quản lý, sử dụng bền vững tài nguyên đất, nước ở các lưu vực, tiểu lưu vực sông trên phạm vi toàn quốc",
      proposing: 0,
      ongoing: 1,
      behind: 0,
      completed: 0,
      total: 1,
    },
    {
      field: "Tài nguyên nước và bảo vệ môi trường",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 2,
      total: 2,
    },
    {
      field:
        "Chỉnh trị sông, bảo vệ bờ biển, phòng chống lũ, lụt và giảm nhẹ thiên tai",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field:
        "Ảnh hưởng của biến đổi khí hậu đến nguồn nước, quy hoạch, xây dựng, vận hành hệ thống thủy lợi, đê điều, thủy sản, nông nghiệp, nông thôn",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field:
        "Thủy nông cải tạo đất và cấp thoát nước; quản lý khai thác và bảo vệ công trình thủy lợi, thủy điện",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field: "Công nghệ xây dựng và bảo vệ công trình thủy lợi, thủy điện",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 1,
      total: 1,
    },
    {
      field: "Vật liệu xây dựng",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field: "Thiết bị cơ điện chuyên dùng thủy lợi",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
    {
      field: "Kinh tế thủy lợi",
      proposing: 3,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 3,
    },
    {
      field: "Công nghệ thông tin và tự động hóa",
      proposing: 2,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 2,
    },
    {
      field: "Nghiên cứu phòng trừ Mối",
      proposing: 0,
      ongoing: 0,
      behind: 0,
      completed: 0,
      total: 0,
    },
  ];

  const researchFieldByManagement = [
    {
      field: "Chiến lược thủy lợi của các vùng, miền và quốc gia",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field:
        "Quy hoạch phát triển và quản lý, sử dụng bền vững tài nguyên đất, nước ở các lưu vực, tiểu lưu vực sông trên phạm vi toàn quốc",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 1,
      other: 0,
      total: 1,
    },
    {
      field: "Tài nguyên nước và bảo vệ môi trường",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field:
        "Chỉnh trị sông, bảo vệ bờ biển, phòng chống lũ, lụt và giảm nhẹ thiên tai",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field:
        "Ảnh hưởng của biến đổi khí hậu đến nguồn nước, quy hoạch, xây dựng, vận hành hệ thống thủy lợi, đê điều, thủy sản, nông nghiệp, nông thôn",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field:
        "Thủy nông cải tạo đất và cấp thoát nước; quản lý khai thác và bảo vệ công trình thủy lợi, thủy điện",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Công nghệ xây dựng và bảo vệ công trình thủy lợi, thủy điện",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Vật liệu xây dựng",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Thiết bị cơ điện chuyên dùng thủy lợi",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Kinh tế thủy lợi",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Công nghệ thông tin và tự động hóa",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      field: "Nghiên cứu phòng trừ Mối",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
  ];

  const unitByManagement = [
    {
      unit: "Viện Khoa học Thủy lợi Miền Nam",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Khoa học Thủy lợi Miền Trung và Tây Nguyên",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Nước, Tưới Tiêu và Môi trường",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 1,
      other: 0,
      total: 1,
    },
    {
      unit: "Viện Thủy công",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Bơm và Thiết bị thủy lợi",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Thủy điện và năng lượng tái tạo",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Kinh tế và Quản lý thủy lợi",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Viện Kỹ thuật Biển",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Phòng Thí nghiệm trọng điểm Quốc gia về động lực học sông biển",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Trung tâm Đào tạo và Hợp tác Quốc tế",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Trung tâm phòng trừ Mối và sinh vật có hại",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Trung tâm công nghệ phần mềm thủy lợi",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
    {
      unit: "Trung tâm Tư vấn quản lý thủy nông có sự tham gia của người dân",
      national: 0,
      ministry: 0,
      provincial: 0,
      institute: 0,
      other: 0,
      total: 0,
    },
  ];

  const year2025Statistics = [
    { id: 14, category: "Đề tài chuyển tiếp từ năm trước", count: 1 },
    {
      id: 15,
      category: "Đề tài mới được phê duyệt Năm 2025 (đang thực hiện)",
      count: 0,
    },
    { id: 16, category: "Đề tài hoàn thành Năm 2025", count: 0 },
  ];

  return (
    <PageShell title="Thống kê Đề tài, nhiệm vụ KHCN">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 min-w-0">
            <button
              onClick={handleGoBack}
              aria-label="Go back"
              className="p-3 rounded-full text-[#337ab7] bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <h1 className="text-lg font-semibold text-gray-800 truncate">
              Thống kê Đề tài, nhiệm vụ KHCN
            </h1>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 bg-[#337ab7] text-white rounded-md hover:bg-[#2c6aa0] transition-colors">
            <Download className="h-4 w-4" />
            Xuất báo cáo
          </button>
        </div>

        {/* Filter Section */}
        <div className="bg-white rounded-lg px-2">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                className="w-96 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="status">Theo trạng thái</option>
                <option value="management">Theo cấp quản lý</option>
                <option value="unit">Theo Đơn vị và trạng thái</option>
                <option value="research">Theo lĩnh vực nghiên cứu</option>
                <option value="research_mgmt">
                  Đang thực hiện theo Lĩnh vực và Cấp quản lý
                </option>
                <option value="unit_mgmt">
                  Đang thực hiện theo Đơn vị và Cấp quản lý
                </option>
                <option value="year2025">
                  Đang triển khai và hoàn thành năm 2025
                </option>
              </select>
            </div>
          </div>
        </div>

        {/* Statistics Table - Show only selected table */}
        {selectedFilter === "status" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Đề tài, nhiệm vụ KHCN
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài, nhiệm vụ KHCN
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-bold uppercase tracking-wider w-24">
                      Số lượng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {statusStatistics.map((item, index) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {item.isMain ? "" : index + 1}
                      </td>
                      <td
                        className={`px-3 py-2 text-sm border-r border-gray-200 ${
                          item.isMain
                            ? "font-bold text-gray-900"
                            : "text-gray-700"
                        }`}
                      >
                        {item.category}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-right w-24">
                        {item.count}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-right w-24">
                      9
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "research" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Theo lĩnh vực nghiên cứu
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài NCKH
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang đề xuất
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang thực hiện
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Chậm tiến độ
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đã hoàn thành
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider">
                      Tổng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {researchFieldStatistics.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.field}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.proposing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.ongoing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                        {item.behind}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.completed}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                        {item.total}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      5
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      1
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      3
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                      9
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "research_mgmt" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Đang thực hiện theo Lĩnh vực nghiên cứu và Cấp quản lý
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài NCKH
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Quốc gia
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Bộ
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Tỉnh/Thành phố
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Viện/ Chi nhánh
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp khác
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider">
                      Tổng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {researchFieldByManagement.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.field}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.national}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.ministry}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.provincial}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.institute}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.other}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                        {item.total}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      1
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                      1
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "unit_mgmt" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Đang thực hiện theo Đơn vị và Cấp quản lý
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài, nhiệm vụ KHCN
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Quốc gia
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Bộ
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Tỉnh/Thành phố
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp Viện/ Chi nhánh
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Cấp khác
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider">
                      Tổng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {unitByManagement.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.unit}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.national}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.ministry}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.provincial}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.institute}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.other}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                        {item.total}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      1
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                      1
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "management" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Theo cấp quản lý
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài NCKH
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang đề xuất
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang thực hiện
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Chậm tiến độ
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đã hoàn thành (2025)
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider">
                      Tổng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {managementLevelStatistics.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.level}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.proposing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.ongoing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                        {item.behind}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.completed}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                        {item.total}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      5
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      1
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                      6
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "unit" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Theo Đơn vị và trạng thái
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài, nhiệm vụ KHCN
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang đề xuất
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đang thực hiện
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Chậm tiến độ
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đã hoàn thành (2025)
                    </th>
                    <th className="px-3 py-2 text-center text-xs font-bold uppercase tracking-wider">
                      Tổng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {unitStatistics.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {index + 1}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.unit}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.proposing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.ongoing}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                        {item.behind}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                        {item.completed}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                        {item.total}
                      </td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-bold">
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16"></td>
                    <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200">
                      Tổng
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      5
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      1
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-red-600 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center border-r border-gray-200">
                      0
                    </td>
                    <td className="px-3 py-2 text-sm font-bold text-gray-900 text-center">
                      6
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedFilter === "year2025" && (
          <div className="bg-white rounded-lg overflow-hidden">
            <div className="px-6 py-4">
              <h3 className="text-lg font-semibold text-[#337ab7]">
                Đang triển khai và hoàn thành năm 2025
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead className="bg-[#337ab7] text-white">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0] w-16">
                      #
                    </th>
                    <th className="px-3 py-2 text-left text-xs font-bold uppercase tracking-wider border-r border-[#2c6aa0]">
                      Đề tài, nhiệm vụ KHCN
                    </th>
                    <th className="px-3 py-2 text-right text-xs font-bold uppercase tracking-wider w-24">
                      Số lượng
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {year2025Statistics.map((item, index) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-3 py-2 text-sm text-gray-900 border-r border-gray-200 w-16">
                        {item.id}
                      </td>
                      <td className="px-3 py-2 text-sm text-gray-700 border-r border-gray-200">
                        {item.category}
                      </td>
                      <td className="px-3 py-2 text-sm font-bold text-gray-900 text-right w-24">
                        {item.count}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </PageShell>
  );
};

export default ProjectStatistics;
